import { CSSProperties } from "react";

export default function IcGDrive({ style, size, color }: { style?: CSSProperties, size?: number, color?: string }) {
  return <svg style={style ? style : {}} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width={size ? size : "100"} height={size ? size : "100"} viewBox="0 0 48 48">
    <path fill="#FFC107" d="M17 6L31 6 45 30 31 30z" />
    <path fill="#1976D2" d="M9.875 42L16.938 30 45 30 38 42z" />
    <path fill="#4CAF50" d="M3 30.125L9.875 42 24 18 17 6z" />
  </svg>
}